<template>
  <div :class="showPdfViewer ? 'parent-container' : ''">
    <div>
      <slot name="left"></slot>
    </div>
    <div v-if="showPdfViewer">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import getPiniaInstance from '@app/shared/pinia/instance'
import { usePdfViewer } from '@app/application/reconciliation_proposal/stores/pdf-viewer'
import { storeToRefs } from 'pinia'

const { showPdfViewer } = storeToRefs(usePdfViewer(getPiniaInstance()))
</script>

<style scoped>
.parent-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
}
</style>
